/**
 * CDMO bulk upload (PHAR-485): the page route, and the allowed values for the CSV's review columns.
 * Kept with the other option lists so the importer never hard-codes a value the template or research
 * prompt defines.
 */

/** Route of the admin-only bulk upload page. */
export const CDMO_IMPORT_PATH = '/admin/cdmo-import';

/** Status of one research answer, as written in each `<group>__status` column. */
export const EVIDENCE_STATUS = {
  VERIFIED: 'Verified',
  INFERRED: 'Inferred',
  MIXED: 'Mixed (Verified + Inferred)',
  UNKNOWN: 'Unknown / Not Verified',
} as const;

export type EvidenceStatus = (typeof EVIDENCE_STATUS)[keyof typeof EVIDENCE_STATUS];

export const EVIDENCE_STATUS_OPTIONS: readonly EvidenceStatus[] = Object.values(EVIDENCE_STATUS);

/**
 * How the research for a row was collected (`collected_via` column). The AI-ready template is meant
 * for Claude or ChatGPT, so each has its own option and the record says which one did the research.
 */
export const COLLECTED_VIA_OPTIONS = [
  'Apify',
  'Claude web research',
  'Apify + Claude web research',
  'ChatGPT web research',
  'Apify + ChatGPT web research',
] as const;
